<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Faktury'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-invoice-details-view *ngIf="!modify" [invoice]="invoice" (modifyClicked)="modify = true"  (changed)="loadInvoice()"></app-invoice-details-view>
    <app-edit-invoice *ngIf="modify"  [invoice]="invoice" (closeModification)="modify = false; loadInvoice()" ></app-edit-invoice>
  </mat-tab>

<!--  <mat-tab label="Prowizje" *ngFor="let invoiceSettlement of invoiceObject?.settlements">-->
<!--  <mat-tab label="Prowizje">-->
<!--    <ng-template matTabContent>-->
<!--      <app-all-commissions-list-invoices-->
<!--        [embeddedView]="true"-->
<!--        [commissionSettlement]="commissionSettlement"-->
<!--        [contract]="contract"-->
<!--        [enableFilters]="[-->
<!--          'billingMonth', 'insuranceCompany', 'importer', 'policyNumber', 'company', 'ofwca', 'collection',-->
<!--          'partnerAssetsRegional', 'notMatched', 'matched',-->
<!--          'createdAt', 'risk', 'status',-->
<!--        ]"-->
<!--      ></app-all-commissions-list-invoices>-->
<!--    </ng-template>-->
<!--  </mat-tab>-->

  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [invoice]="invoice"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
